

function categoryClick() {
    var name = $(this).data("name");
    var priority = $(this).data("priority");

    $("#feedbackCategory").attr("data-name", name);
    $("#feedbackCategory").attr("data-priority", priority);

    $(".feedback-category").each(function () {
        $(this).removeClass("active");
    });

    $(this).addClass("active");
    $(".feedback-step2").slideDown();

    console.log(name + " - " + priority);
}

function hideModal() {
    $(".feedback-category").each(function () {
        $(this).removeClass("active");
    });

    $(".feedback-step2").hide();
    clearValues();
}

function postFeedback() {
    var comment = $("#feedbackComment").val();
    var priority = parseInt($("#feedbackCategory").data("priority"));
    var typeName = $("#feedbackCategory").data("name");
    var pageId = $("#feedbackPage").data("pageid");

    var model = {
        Comment: comment,
        ParentId: pageId,
        Category: { Name: typeName, Priority: priority }
    };
    var postUrl = window.siteSettings.apihost + "/umbraco/api/feedback/Post";


    $.ajax({
        type: "POST",
        url: postUrl,
        data: model,
        success: success,
        error: error,
        dataType: "json"
    });

    clearValues();
}

function clearValues() {
    $("#feedbackComment").val("");
    $("#feedbackCategory").attr("data-name", "");
    $("#feedbackCategory").attr("data-priority", "");
}

function success(e) {
    $("form.feedback-holder .feedback-step1").css("display", "none");
    $("form.feedback-holder .feedback-step2").css("display", "none");
    $(".feedback-result-ok").css("display", "block");
}

function error(e) {
    $("form.feedback-holder .feedback-step1").css("display", "none");
    $("form.feedback-holder .feedback-step2").css("display", "none");
    $(".feedback-result-error").css("display", "block");
}

$(document).ready(function () {


    $("#feedbackForm").on("submit", function (e) {
        e.preventDefault();
        return false;
    });

    if ($(".feedback-holder").length > 0) {

        $("#feedbackSendButton").click(postFeedback);

    }
});